import { ReactNode } from 'react';
import { InfoBox } from '../InfoBox';

interface NoResultsMessageProps {
    /**
     * Optional custom message. Defaults to "Found no results."
     */
    message?: string;
    /**
     * Optional hint/description shown below the main message
     */
    hint?: string;
    /**
     * Optional className for the wrapper div
     */
    className?: string;
}

export function NoResultsMessage({
    message = 'Found no results.',
    hint = 'Try broadening your search or adjusting your filters.',
    className,
}: NoResultsMessageProps): ReactNode {
    return (
        <div
            className={
                className ||
                'flex align-items-center justify-content-center flex-1 py-4'
            }
        >
            <InfoBox iconSize="normal">
                <div className="flex flex-column gap-1">
                    <span className="font-semibold">{message}</span>
                    {hint && (
                        <span className="text-sm text-color-secondary">
                            {hint}
                        </span>
                    )}
                </div>
            </InfoBox>
        </div>
    );
}
